export const caseStudies = [
  {
    id: 'topazery-commerce',
    title: 'Luxury Commerce Overhaul',
    client: 'Topazery',
    industry: 'Luxury jewelry',
    timeframe: '6 weeks',
    heroImage: 'topazery/topazery_luxury_upgrade.png',
    summary:
      'Rebuilt the flagship ecommerce experience with a luxury visual language, faster storefront, and higher-converting checkout.',
    outcomes: [
      { label: 'Conversion lift', value: '+25%' },
      { label: 'LCP improvement', value: '-42%' },
      { label: 'Average order value', value: '+$84' },
    ],
    tags: ['Ecommerce', 'Performance', 'UX'],
    projectURL: 'https://www.topazery.com/',
    beforeAfterImages: [
      {
        title: 'Homepage Transformation',
        before: {
          src: 'topazery/topazery.com_old_home.png',
          alt: 'Original Topazery homepage',
        },
        after: {
          src: 'topazery/topazery_new_home.png',
          alt: 'Luxury-focused Topazery homepage',
        },
      },
      {
        title: 'Category Page Clarity',
        before: {
          src: 'topazery/topazery_old_category_page.png',
          alt: 'Old category layout',
        },
        after: {
          src: 'topazery/topazery_luxury_upgrade.png',
          alt: 'Updated category layout',
        },
      },
    ],
    galleryImages: [
      {
        src: 'topazery/promo_section.png',
        alt: 'Promotional storytelling section',
        title: 'Promotional storytelling',
      },
      {
        src: 'topazery/promo_banner.png',
        alt: 'Premium banner design',
        title: 'Premium banner',
      },
      {
        src: 'topazery/topazery_old_contact.png',
        alt: 'Legacy contact page',
        title: 'Legacy contact flow',
      },
    ],
  },
  {
    id: 'topazery-content',
    title: 'Content System Refresh',
    client: 'Topazery Blog',
    industry: 'Luxury jewelry editorial',
    timeframe: '4 weeks',
    heroImage: 'topazery/topazeryblog_homepage_.png',
    summary:
      'Modernized the editorial experience with clearer navigation, structured content, and SEO wins that drove sustained traffic.',
    outcomes: [
      { label: 'Organic growth', value: '+18%' },
      { label: 'Bounce rate', value: '-22%' },
      { label: 'Time on page', value: '+31%' },
    ],
    tags: ['Content', 'SEO', 'Experience'],
    projectURL: 'https://www.topazery.com/',
    beforeAfterImages: [
      {
        title: 'Contact Experience',
        before: {
          src: 'topazery/topazery_old_contact.png',
          alt: 'Original contact experience',
        },
        after: {
          src: 'topazery/topazery_new_home.png',
          alt: 'Refreshed visual system',
        },
      },
    ],
    galleryImages: [
      {
        src: 'topazery/topazery_old_faqs.png',
        alt: 'FAQ layout before improvements',
        title: 'Pre-optimization FAQ',
      },
      {
        src: 'topazery/topazery_old_how_to_order.png',
        alt: 'Instructional flow before rewrite',
        title: 'Instructional flow (legacy)',
      },
      {
        src: 'topazery/topazery_old_learn.png',
        alt: 'Learning center pre-upgrade',
        title: 'Learning center (legacy)',
      },
    ],
  },
  {
    id: 'jku-leadgen',
    title: 'Service Brand Relaunch',
    client: 'JK Unlimited Services',
    industry: 'Construction & services',
    timeframe: '2 months',
    heroImage: 'jku/new_jk_home.png',
    summary:
      'Repositioned the brand with clearer offers, mobile-first performance, and structured lead capture for local search.',
    outcomes: [
      { label: 'Lead volume', value: '+34%' },
      { label: 'Page speed', value: '-1.6s LCP' },
      { label: 'Local SEO', value: '+3 map pack wins' },
    ],
    tags: ['Local SEO', 'Conversion', 'CMS'],
    projectURL: 'http://www.jkunlimitedservices.com/',
    beforeAfterImages: [
      {
        title: 'Homepage Clarity',
        before: {
          src: 'jku/www.jkunlimitedservices.com_.png',
          alt: 'Original homepage',
        },
        after: {
          src: 'jku/JKU_home_upgrade.png',
          alt: 'Upgraded homepage',
        },
      },
      {
        title: 'Services Narrative',
        before: {
          src: 'jku/www.jkunlimitedservices.com_services.php.png',
          alt: 'Original services page',
        },
        after: {
          src: 'jku/new_jk_services.png',
          alt: 'New services storytelling',
        },
      },
    ],
    galleryImages: [
      {
        src: 'jku/new_jk_gallery.png',
        alt: 'Gallery layout upgrade',
        title: 'Gallery layout',
      },
      {
        src: 'jku/new_jk_contact.png',
        alt: 'Contact flow redesign',
        title: 'Contact flow',
      },
    ],
  },
  {
    id: 'sbs-launch',
    title: 'Zero-to-One Launch',
    client: 'SBS Property Transformations',
    industry: 'Home services',
    timeframe: '1 month',
    heroImage: 'sbs/sbsproperty.services.png',
    summary:
      'Created a conversion-focused site with before/after storytelling, local SEO, and fast performance to establish credibility quickly.',
    outcomes: [
      { label: 'Launch timeline', value: '30 days' },
      { label: 'Core Web Vitals', value: '90+ CWV' },
      { label: 'Lead conversion', value: '+19%' },
    ],
    tags: ['Go-to-market', 'Performance', 'Local'],
    projectURL: 'https://www.sbsproperty.services/',
    beforeAfterImages: [],
    galleryImages: [],
  },
  {
    id: 'topazery-resilience',
    title: 'Resilience & Recovery UX',
    client: 'Topazery',
    industry: 'Luxury jewelry',
    timeframe: '3 weeks',
    heroImage: 'topazery/new_404.png',
    summary:
      'Designed failure-state experiences (404/empty states/promo flows) that keep shoppers in the journey and protect revenue.',
    outcomes: [
      { label: 'Bounce rate', value: '-17%' },
      { label: 'Return-to-shop', value: '+22%' },
      { label: 'Promo CTR', value: '+14%' },
    ],
    tags: ['UX Writing', 'Retention', 'Experimentation'],
    projectURL: 'https://www.topazery.com/',
    beforeAfterImages: [
      {
        title: '404 Recovery',
        before: {
          src: 'topazery/old_404.png',
          alt: 'Old 404 page',
        },
        after: {
          src: 'topazery/new_404.png',
          alt: 'New recovery page',
        },
      },
    ],
    galleryImages: [
      {
        src: 'topazery/promo_banner.png',
        alt: 'Promo banner exploration',
        title: 'Promo banner system',
      },
    ],
  },
];
